module.exports = __webpack_public_path__ + "img/logo-logomark.bb5d30fe.png";